import { BoundedContent, Card } from '@vp/swan'
import { areContentfulLinksEnabled, getContentfulLink, isBrowser, isDebugPageEnabled, validateContentfulContext, validateContentfulMetadata } from './utils'
import { useContentfulContext } from './ContentfulContext'
import { PropsWithChildren } from 'react'
import { DebugSectionProps } from 'src/types'

export const DebugSection : React.FC<PropsWithChildren<DebugSectionProps>> = ({ contentfulMetadata, availability, search, children }) => {
  const contentfulContext = useContentfulContext()
  const debugModeEnabled = isBrowser() && (areContentfulLinksEnabled() || isDebugPageEnabled())
  const enoughInfo = validateContentfulContext(contentfulContext) && validateContentfulMetadata(contentfulMetadata)

  if (!debugModeEnabled || !enoughInfo) {
    return (
      <>
        {children}
      </>
    )
  }

  return (
    <BoundedContent my={4}>
      <Card bgc='accent'>
        <h2>Debug information</h2>
        <ul>
          <li key='title'>
            Contentful Link:
            <a href={getContentfulLink(contentfulContext, contentfulMetadata.contentful_id)}>
              {contentfulMetadata.contentfulName} (id: {contentfulMetadata.contentful_id})
            </a>
          </li>
          <li key='availability'>
            availability:
            <ul>
              {Object.keys(availability).map((key, index) => {
                const typedKey = key as keyof typeof availability
                return availability[typedKey]
                  ? (
                    <li key={`li_${index}`}>
                      {key}: {availability[typedKey]}
                    </li>
                    )
                  : (
                    <></>
                    )
              })}
            </ul>
          </li>
        </ul>
      </Card>
    </BoundedContent>
  )
}
